import React from 'react';
import PropTypes from 'prop-types';

import { Table } from 'react-bootstrap';

import DeductionCategoryRow from './row';
import DeductionCategoryModal from './modal';
import EmptyState from 'bundles/settings/empty_state';
import DeductionCategoriesIcon from 'deduction_categories.svg';
import AddControl from 'components/add_control';

import './styles.scss';

class DeductionCategories extends React.Component {
  static propTypes = {
    categories: PropTypes.array.isRequired,
    deductionCategoriesPath: PropTypes.string.isRequired,
    enableHouseDeductions: PropTypes.bool,
    enableTieredDeductions: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
  }

  state = {}

  showModal = () => {
    this.setState({ showModal: true });
  }

  hideModal = () => {
    this.setState({ showModal: false });
  }

  addDeductionCategory = (category) => {
    this.props.onChange([...this.props.categories, category]);
    this.hideModal();
  }

  updateDeductionCategory = (oldName, updatedCategory) => {
    this.props.onChange(this.props.categories.map(category => category.name === oldName ? updatedCategory : category));
    this.hideModal();
  };

  removeDeductionCategory = (name) => {
    this.props.onChange(this.props.categories.filter(category => category.name != name));
  }

  isEmpty() {
    return this.props.categories.length === 0;
  }

  render() {
    return (
      <div className="row">
        <div className="col-xs-12 deduction-categories-index">
          <h3 className="mt-0">Deduction Categories</h3>

          {!this.isEmpty() && (<div className="d-flex justify-content-end align-items-center mb-3">
            <AddControl className="ml-3" name="add-category" onClick={this.showModal}>
              Add Category
            </AddControl>
          </div>)}

          {this.isEmpty() ? this.renderEmptyState() : this.renderCategories()}

          <DeductionCategoryModal
            deductionCategoriesPath={this.props.deductionCategoriesPath}
            enableHouseDeductions={this.props.enableHouseDeductions}
            enableTieredDeductions={this.props.enableTieredDeductions}
            show={this.state.showModal}
            onCancel={this.hideModal}
            onSave={this.addDeductionCategory}
          />
        </div>
      </div>
    );
  }

  categorySorter = (catA, catB) => {
    if (!catA.voucherCategory) return 1;
    if (!catB.voucherCategory) return -1;

    return catA.tier - catB.tier;
  };

  renderCategories() {
    return (
      <div className="backoffice-settings-table-wrapper sticky-actions">
        <Table responsive>
          <thead>
            <tr>
              <th colSpan={this.props.enableTieredDeductions ? 3 : 6}>Category</th>
              <th colSpan="3">Deduction Types</th>
              {this.props.enableTieredDeductions && <th colSpan="3">Pre-Split Deduction Tier</th>}
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {this.props.categories.sort(this.categorySorter).map(category => (
              <DeductionCategoryRow
                deductionCategoriesPath={this.props.deductionCategoriesPath}
                enableHouseDeductions={this.props.enableHouseDeductions}
                enableTieredDeductions={this.props.enableTieredDeductions}
                houseCategory={category.houseCategory}
                key={category.name}
                name={category.name}
                paymentCategory={category.paymentCategory}
                tier={category.tier}
                voucherCategory={category.voucherCategory}
                onDeleteCategory={this.removeDeductionCategory}
                onUpdateCategory={this.updateDeductionCategory}
              />
            ))}
          </tbody>
        </Table>
      </div>
    );
  }

  renderEmptyState() {
    return (
      <EmptyState
        buttonText="Add Deduction Category"
        iconClassNames="deduction-categories"
        imageSrc={DeductionCategoriesIcon}
        message="No deduction categories have been added yet"
        onClick={this.showModal}
      />
    );
  }
}

export default DeductionCategories;
